// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1pfk5","list":"styles_list__21uoW"};